<!-- 設定保存ダイアログ -->
<b-modal v-model="modal_requirement_122" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      <template v-if="phase === 'start' || phase === 'execConfirm'">
        {{ $t('message.common_title_confirmation') }}
      </template>
      <template v-if="phase === 'execute'">
        {{ $t('individual.common_title_execution') }}
      </template>
      <template v-if="phase === 'success'">
        {{ $t('message.common_title_success') }}
      </template>
      <template v-if="phase === 'error' || phase === 'failed'">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>

  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 待機-注意事項 -->
        <template v-if="phase === 'start'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                $t(`${i18nWsKey}.REQ_WS_122_TXT_1`) }}
              </div>
            </div>
          </div>
        </template>
        <!-- 待機-実施確認 -->
        <template v-if="phase === 'execConfirm'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                $t(`${i18nWsKey}.REQ_WS_122_TXT_2`) }}
              </div>
            </div>
          </div>
        </template>
        <!-- 実行 -->
        <template v-if="phase === 'execute'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                displayInfo }}
              </div>
            </div>
          </div>
        </template>
        <!-- 正常終了 -->
        <template v-if="phase === 'success'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                $t(`${i18nWsKey}.REQ_WS_122_TXT_4`) }}
              </div>
            </div>
          </div>
        </template>
        <!-- エラー -->
        <template v-if="phase === 'error'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                $t(`${i18nWsKey}.REQ_WS_122_TXT_5`) }}
              </div>
            </div>
          </div>
        </template>
        <!-- 異常終了(エラー) -->
        <template v-if="phase === 'failed'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                $t(`individual.error_communication_error`) }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <template v-if="phase === 'start'">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="clickOk" class="mx-2">
          {{ $t('message.button_agreement_confirm') }}
        </b-button>
      </template>
      <template v-if="phase === 'execConfirm'">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="execute" class="mx-2">
          {{ $t('message.button_agreement_confirm') }}
        </b-button>
      </template>
      <template v-if="phase === 'success'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <template v-if="phase === 'error'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="closeError" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <template v-if="phase === 'failed'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="exit" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>